import { showCustomToast } from 'common/components/CustomToast/utils';
import React from 'react';

import {
  MessageUserCreate,
  MessageUserCreateVariables,
} from './__generated__/MessageUserCreate';
import { useMutation } from '@apollo/client';
import {
  CreateMessageData,
  CreateNewMessage,
} from 'common/components/CreateNewMessage';
import { MESSAGES_PER_PAGE } from 'common/constants';
import ADD_NEW_MESSAGE from './MessageUserCreate.graphql';
import GET_USER_MESSAGES from '../GetUserMessages.graphql';

interface CreateNewMessageViewProps {
  onMessageCreate?: () => void;
}

export const NewMessage: React.FC<CreateNewMessageViewProps> = ({
  onMessageCreate,
}) => {
  const [createMessage, { loading }] = useMutation<
    MessageUserCreate,
    MessageUserCreateVariables
  >(ADD_NEW_MESSAGE, { errorPolicy: 'all' });

  const onSubmit = async (formData: CreateMessageData) => {
    const { messageComment, reminderDates, isResponseRequired, receivers } = {
      ...formData,
    };
    const { communicationChannel, department, user } = { ...receivers };
    const { errors } = await createMessage({
      variables: {
        input: {
          message: { messageComment, reminderDates, isResponseRequired },
          communicationChannel,
          department,
          user,
        },
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GET_USER_MESSAGES,
          variables: {
            first: MESSAGES_PER_PAGE,
            filter: { _isOutgoingMessage: { equalTo: true } },
          },
        },
      ],
    });
    if (!errors) {
      onMessageCreate?.();
      showCustomToast({
        content: 'Message sent successfully.',
        appearance: 'success',
      });
    } else
      showCustomToast({
        content: `${errors[0].message}`,
        appearance: 'error',
      });
  };

  return <CreateNewMessage onSubmit={onSubmit} loading={loading} />;
};
